import styles from "./navbar.module.css";
import NavItem from "./navitem";
export default function PageNavbar() {
  return (
    <nav className={styles.navbar}>
      <ul>
        <NavItem title={{label: "Elsykkel", url: "/sok?q=elsykkel"}} />
        <NavItem title={{label: "Lastesykkel", url: "/sok?q=lastesykkel"}} />
        <NavItem
          title="Sykkelutstyr"
          subitems={[
            "Pedaler",
            "Sykkelsko",
            "Mekkestativ",
            {label: "Pumper", url: "/sok?q=Sykkel pumpe"},
            "Demper",
            "Sykkelcomputer",
            "Sykkelvesker",
            "Sykkelstativ"
          ]}
        />
        <NavItem title={{label: "SUP Standup Padel", url: "/sok?q=SUP brett"}} />  
        <NavItem
          title="Løpesko"
          subitems={[
            {label: "Sko herre", url: "/sok?q=Løpesko herre"},
            {label: "Sko dame", url: "/sok?q=Løpesko dame"},
            {label: "Sko junior", url: "/sok?q=Løpesko junior"},
            {label: "Sko terrengløp", url: "/sok?q=Løpesko terreng"},
            {label: "Sko asfalt", url: "/sok?q=Løpesko asfalt"},
            {label: "Løpejakke", url: "/sok?q=Løpejakke"},
            {label: "Løpebukse", url: "/sok?q=Løpebukse"},
            "Mellomlag løping"
          ]}
        />
        <NavItem
          title="Trening"
          subitems={[
            "Tredemølle",
            "Kettlebell",
            "Håndvekt",
            "Vektskiver",
            "Vektstang",
            "Protein",
            "Ryggsekk",
            "Pulsmåler",
            "Garmin"
          ]}
        />
        <NavItem
          title="Tur & Friluft"
          subitems={[
            "Fiskestang",
            { label: "Fiskeutstyr", url: "/sok?q=Fiske" },
            "Tursko",
            "Jakker",
            "Regntøy",
            "Skalljakker",
            "Dykkeutstyr",]}
        />
      </ul>
    </nav>
  );
}
